import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { AdminAddGpsTypeComponent } from "../admin-add-gps-type/admin-add-gps-type.component";
import { AdminEditGpsTypeComponent } from "../admin-edit-gps-type/admin-edit-gps-type.component";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-gps-type",
  templateUrl: "./admin-gps-type.component.html",
  styleUrls: ["./admin-gps-type.component.css"],
})
export class AdminGpsTypeComponent implements OnInit {
  GpsTypeData: any = [];
  displayedColumns: string[] = [
    "_id",
    "server_name",
    "server_url",
    "createdAt",
    "updatedAt",
    "action",
  ];
  dataSource = new MatTableDataSource<any[]>(this.GpsTypeData);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  token: any;
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  document_array: any = [];
  last_page: any = 1;
  toggleSearch: boolean = false;
  searchButton: boolean = true;
  ServerName: any = -1;
  perpage: any = 10;
  page: any = 1;
  loading: boolean = false;
  GPSType: boolean = true;
  addBtn: boolean = true;
  search_btn: boolean = false;
  clear_Btn: boolean = false;
  @ViewChild("newItem") newItem: ElementRef;

  constructor(
    private matDialog: MatDialog,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.getGpsType(this.ServerName);
    this.pagination(1);
    let triptype = "gpsType";
    localStorage.setItem("tripType", triptype);
  }

  onInputChange(value: any) {
    if (value.length == 0) {
      this.resetSearch();
    }
  }

  ngAfterViewInit() {
    this.GpsTypeData.paginator = this.paginator;
  }

  public getGpsType(type: any) {
    this.ServerName = type;
    this.loading = true;
    this.service
      .GetGpsType(this.token, this.ServerName, this.perpage, this.startPage)
      .subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === 200) {
            this.GpsTypeData = response.body.data;
            this.document_array.push(response.body.meta);
            this.last_page = response.body.meta.lastPage;
            this.dataSource.data = this.GpsTypeData;
          }
        },
        (error) => {
          this.loading = false;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public addGPSType(type: any, item: any) {
    let matDialogueAdd = this.matDialog.open(AdminAddGpsTypeComponent, {
      height: "70vh",
      data: {
        type: type,
        data: item,
      },
      autoFocus: false,
    });
    matDialogueAdd.afterClosed().subscribe((res: any) => {
      this.getGpsType(this.ServerName);
    });
  }

  public DeleteGpsType(gpsId: any) {
    this.service.DeleteGpsType(this.token, gpsId).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.snackBar.open("Deleted Successfully", "Success", {
            duration: 5000,
          });
          this.getGpsType(this.ServerName);
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  editGpsType(element: any) {
    let matdialogEditGps = this.matDialog.open(AdminEditGpsTypeComponent, {
      height: "70vh",
      data: {
        item: element,
      },
      autoFocus: false,
    });
    matdialogEditGps.afterClosed().subscribe((res: any) => {
      this.getGpsType(this.ServerName);
    });
  }

  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
  }

  openSearch() {
    this.toggleSearch = true;
    this.searchButton = false;
    this.searchButton = false;
    this.search_btn = true;
    this.clear_Btn = false;
    this.addBtn = true;
  }

  search(value: string) {
    this.clear_Btn = true;
    this.search_btn = false;
    this.searchButton = false;
    this.getGpsType(value);
  }

  resetSearch() {
    this.ServerName = "";
    this.getGpsType(this.ServerName);
    this.searchButton = true;
    this.toggleSearch = false;
    this.addBtn = true;
  }
}
